// import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import login from './LoginReducer';
import {reducer as formReducer } from 'redux-form';
import pureActionStates from './PureActionReducer';
import storage from 'redux-persist/lib/storage' 
import { persistCombineReducers } from 'redux-persist'

const config = {
  key: 'root',
  storage,
  blacklist: ['pureActionStates','login','form']
};

const rootReducer = persistCombineReducers(config,{
  login,
  pureActionStates,
  form: formReducer,
  routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js